import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '../button';

import CertificateIcon from '../certificate-icon/certificate-icon';
import css from './certificate-template.scss';
// import { PRIMARY, SECONDARY, CERTIFICATE_URLS } from './certificate-template-constants';
import {
    BRONZE_CERT_TYPE,
    SILVER_CERT_TYPE,
    GOLD_CERT_TYPE,
    PLATINUM_CERT_TYPE,
    EMERALD_CERT_TYPE,
    DIAMOND_CERT_TYPE,
    EPIC_CERT_TYPE,
    LEGEND_CERT_TYPE,
    BRONZE_CERT_TYPE_PAST,
    GOLD_CERT_TYPE_PAST,
    SILVER_CERT_TYPE_PAST
} from '../../containers/certificates/certificates-constants';
import DownloadIcon from '../../assets/images/download-icon.svg';

/**
 * CertificateTemplate pro-forma template for stateless component
 * Displays certificate template with preview image and button to download
 * Calls onDownload prop when user clicks download button
 */

const CertificateTemplate = ({
    template,
    onDownload,
    downloadCertificatesState }) => {
    const { type, total, label, isAllStudents } = template;
    const disabled = total === 0;
    const { isActive, downloadType } = downloadCertificatesState;
    const hasSpinner = isActive && type === downloadType;
    return (
        <div className={`${css['certificate-template']} ${type.toLowerCase()}`} key={type}>
            <CertificateIcon className={css.icon} rank={type} total={isAllStudents ? 5 : total} />
            <p className={css['certificate-type']}>{label}</p>
            <div className={css['btn-container']}>
                <Button
                    className={`${css['download-btn']} ${total === 0 ? css.disabled : ''}`}
                    text={disabled ? '-' : total}
                    icon={hasSpinner ? '' : DownloadIcon}
                    hasSpinner={hasSpinner}
                    btnType={type}
                    primary
                    onClick={onDownload}
                    type={Button.LOZENGE}
                    alignIcon={Button.RIGHT}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

CertificateTemplate.propTypes = {
    template: PropTypes.shape({
        type: PropTypes.oneOf([
            BRONZE_CERT_TYPE,
            SILVER_CERT_TYPE,
            GOLD_CERT_TYPE,
            PLATINUM_CERT_TYPE,
            EMERALD_CERT_TYPE,
            DIAMOND_CERT_TYPE,
            EPIC_CERT_TYPE,
            LEGEND_CERT_TYPE,
            BRONZE_CERT_TYPE_PAST,
            SILVER_CERT_TYPE_PAST,
            GOLD_CERT_TYPE_PAST
        ]),
        total: PropTypes.number,
        label: PropTypes.string
    }),
    // schoolType: PropTypes.oneOf([PRIMARY, SECONDARY]),
    onDownload: PropTypes.func,
    downloadCertificatesState: PropTypes.object
};


function mapStateToProps(state) {
    return { downloadCertificatesState: state.downloadCertificatesState };
}

export default connect(mapStateToProps)(CertificateTemplate);



// WEBPACK FOOTER //
// ./components/certificate-template/certificate-template.js